import * as React from "react";
import * as ReactDOM from "react-dom";

import { Suit, SuitedNumber } from "./common";
import { Hand } from "./components/Hand";

ReactDOM.render(
  <Hand
    cards={[
      new SuitedNumber(Suit.Blue, 5),
      new SuitedNumber(Suit.Blue, 7),
      new SuitedNumber(Suit.Blue, 8),
      new SuitedNumber(Suit.Yellow, 2),
      new SuitedNumber(Suit.Green, 1),
      new SuitedNumber(Suit.Green, 3),
      new SuitedNumber(Suit.Rockets, 4)
    ]}
  />,
  document.getElementById("container")
);
